import { render, staticRenderFns } from "./SkillsMultiselectNew.vue?vue&type=template&id=60631ed6"
import script from "./SkillsMultiselectNew.vue?vue&type=script&lang=ts"
export * from "./SkillsMultiselectNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60631ed6')) {
      api.createRecord('60631ed6', component.options)
    } else {
      api.reload('60631ed6', component.options)
    }
    module.hot.accept("./SkillsMultiselectNew.vue?vue&type=template&id=60631ed6", function () {
      api.rerender('60631ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/SkillsMultiselectNew.vue"
export default component.exports